<template>
  <div class="big">
    <div class="page_title flex between">
      <span>
        投诉类型维护</span>
      <el-button type="primary"
                 style="width:92px"
                 size="medium"
                 @click="back">返回</el-button>
    </div>
    <div style="padding: 20px">
      <div class="container">
        <div style="text-align:left;margin-bottom:10px">
          <el-button type="primary"
                     :disabled="
                        module_id_array[0]
                          ? !module_id_array.includes('914')
                          : false
                      "
                     @click="addTypeDia(0)">添加投诉类型</el-button>
        </div>
        <div style="border: solid 1px #c9cbd6">
          <el-table ref="multipleTable"
                    :data="tableData"
                    tooltip-effect="dark"
                    style="width: 100%; min-width: 1000px"
                    :header-cell-style="{ background: '#F5F5F5' }">

            <el-table-column label="投诉类型"
                             prop="complaint_title">
            </el-table-column>
            <el-table-column prop="complaint_desc"
                             label="描述" />
            <el-table-column label="操作">
              <template slot-scope="scope">
                <el-button type="text"
                           @click="addTypeDia(scope.row)"
                           :disabled="
                        module_id_array[0]
                          ? !module_id_array.includes('914')
                          : false
                      ">编辑</el-button>
                <el-button type="text"
                           @click="delType(scope.row.complaint_type_id)"
                           :disabled="
                        module_id_array[0]
                          ? !module_id_array.includes('915')
                          : false
                      ">删除</el-button>
              </template>
            </el-table-column>
          </el-table>
        </div>
      </div>
    </div>

    <!-- 类型维护 -->
    <el-dialog :title="title"
               :visible.sync="typeDia"
               width="450px"
               style="text-align: left"
               :close-on-click-modal="false"
               center>
      <div class="content">
        <div>
          <span class="label">投诉类型</span>
          <el-input v-model="add_data.complaint_title"
                    maxlength="10"
                    style="width:300px"></el-input>
        </div>
        <div>
          <span class="label">备注</span>
          <el-input type="textarea"
                    :autosize="{ minRows: 3, maxRows: 6}"
                    v-model="add_data.complaint_desc"
                    maxlength="50"
                    style="width:300px">
          </el-input>
        </div>
      </div>
      <span slot="footer"
            class="dialog-footer">
        <el-button @click="typeDia = false"
                   plain>取消</el-button>
        <el-button type="primary"
                   @click="saveDoctorComplaintTypeInfo">确 定</el-button>
      </span>

    </el-dialog>
  </div>
</template>
<script>
export default {
  data() {
    return {
      tableData: [],
      title: '添加投诉类型',
      typeDia: false,
      add_data: {
        complaint_type_id: '',
        complaint_title: '',
        complaint_desc: ''
      }
    };
  },
  computed: {
    module_id_array() {
      return this.$store.state.userInfo.userInfo.module_id_array;
    }
  },
  created() {
    this.getList();
  },
  methods: {
    //获取投诉类型
    getList() {
      this.axios
        .post('platform/activity/getDoctorComplaintTypeList')
        .then((res) => {
          this.tableData = res.data.list;
        });
    },
    //打开弹窗
    addTypeDia(row) {
      if (row) {
        this.title = '编辑投诉类型';
        this.add_data = {
          complaint_type_id: row.complaint_type_id,
          complaint_title: row.complaint_title,
          complaint_desc: row.complaint_desc
        };
      } else {
        this.title = '添加投诉类型';
        this.add_data = {
          complaint_type_id: 0,
          complaint_title: '',
          complaint_desc: ''
        };
      }
      this.typeDia = true;
    },
    //提交类型维护
    saveDoctorComplaintTypeInfo() {
      let data = this.add_data;
      this.axios
        .post('platform/activity/saveDoctorComplaintTypeInfo', data)
        .then((res) => {
          this.$message({
            message: '提交成功',
            type: 'success'
          });
          this.getList();
          this.typeDia = false;
        });
    },
    //删除
    delType(complaint_type_id) {
      this.$confirm('确定删除该类型吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消'
      })
        .then(() => {
          this.axios
            .post('platform/activity/deleteDoctorComplaintTypeInfo', {
              complaint_type_id
            })
            .then((res) => {
              this.$message({
                message: '删除成功',
                type: 'success'
              });
              this.getList();
            });
        })
        .catch(() => {});
    },
    back() {
      history.back();
    }
  }
};
</script>

<style lang="scss" scoped>
.text_over {
  display: inline-block;
  white-space: nowrap;
  overflow: hidden;
  width: 80px;
  text-overflow: ellipsis;
}
.container {
  padding: 20px;
  box-sizing: border-box;
  background-color: #ffffff;
  min-height: calc(100vh - 140px);
}
.el-table__expand-icon--expanded {
  display: none;
}
.el-table .expanded {
  background-color: #f9f8ee;
}
.filterBox {
  flex-wrap: wrap;
  align-items: center;
  .box {
    margin-right: 22px;
    margin-bottom: 12px;
    align-items: center;
    .label {
      margin-right: 10px;
    }
  }
  .search-button {
    background-color: #eceff2;
    color: #747981;
  }
}
.complaint_desc {
  text-overflow: -o-ellipsis-lastline;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 3;
  line-clamp: 3;
  -webkit-box-orient: vertical;
}
.content {
  padding: 20px;
  div {
    display: flex;
    margin-bottom: 16px;
  }
  .label {
    display: inline-block;
    min-width: 80px;
    font-weight: 700;
    font-size: 14px;
  }
}
</style>
<style lang="scss">
.el-image > img {
  height: 100px;
  width: auto;
  display: block;
}
.el-image-viewer__close {
  i {
    color: #ffffff;
  }
}
</style>


